module.exports = __webpack_public_path__ + "img/active.655264ab.png";